<script lang="ts">
    import { _ } from 'svelte-i18n'
    import { push } from 'svelte-spa-router'
    import { createEventDispatcher } from 'svelte'
    import { clickOutside, declination } from './../../helpers/index.js'
    import { INotice, INoticeComment, NoticeTypes } from '../../types/index.js'
    
    import Modal from './Modal.svelte'
    import DateComponent from './DateComponent.svelte'

    export let notice: INotice
    export let isGreenFlow;

    const dispatch = createEventDispatcher<{ 
        'hide-modal', 
        'handle-visible': { noticeId: number } 
    }>()

    let isOpenActionsModal: boolean = false
    let isReply: boolean
    let commentData: INoticeComment
    let avatarDefault: string = '/static/avatar.wepb'

    $: isReply = notice.notice_type === NoticeTypes.REPLY_TO_COMMENT
    $: commentData = notice[isReply ? 'sender_comment' : 'receiver_comment']

    const openCommentFromNotice = (): void => {
        // Хэш необходим для исправления бага роутера
        // а именно ререндер компонента сущности при нажатии
        // на уведомление
        const hash: string = (Math.random() + 1).toString(36).substring(7)

        const params: string = !notice.new_publication
            ? `?comment_target_id=${commentData.pk}&hash=${hash}`
            : ''

        const paths = {
            'topic': 'topic',
            'feed': 'publicate',
        }

        push(`/${paths[notice.publication.section]}/${notice.publication.pk}/${params}`)

        dispatch('hide-modal')
    }

    const openActionsModal = (): void => {
        isOpenActionsModal = !isOpenActionsModal
    }

    const handleVisibleNotice = (): void => {
        dispatch('handle-visible', { noticeId: notice.id })
        isOpenActionsModal = false
    }

    const getNoticeText = (): string => {
        return `“${commentData.text_web.slice(0, 25)}”${commentData.text_web.length > 25 ? '...' : ''}`.replaceAll('<br>', ' ')
    }

    const getReiciverText = () => {
        return `${notice.receiver_comment.text_web}`.replaceAll('<br>', ' ')
    }
</script>

{#if notice}
    <div 
        class="notice" 
        class:new={!notice.read}
        on:click|stopPropagation={openCommentFromNotice}
    >
        {#if notice.is_hidden}
            <div class="hidden-text flex">
                <div>{$_('hiddenNotification')}</div>
                <div class="restore" on:click|stopPropagation={handleVisibleNotice}>
                    {$_('restore')}
                </div>
            </div>
        {/if}

        {#if !notice.is_hidden}
            <div class="notice-header">
                {#if !notice.new_publication}
                    <div 
                        class="avatar"
                        style:background={`url("${notice.sender_jwt_client.avatar_url || avatarDefault}") no-repeat center/cover`}
                    />

                    <i class="icon-{isReply ? 'comment' : 'heart'}-solid" />

                    <div class='title ellipsis'>
                        {`${notice.sender_jwt_client.first_name} ${notice.sender_jwt_client.last_name}`}
                    </div>
                {:else}
                    <svg 
                        width="22" 
                        height="22" 
                        viewBox="0 0 22 22" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path 
                            fill="{notice.new_publication.color}" 
                            fill-rule="evenodd" 
                            clip-rule="evenodd" 
                            d="M0.37931 0C0.169823 0 0 0.169823 0 0.37931V21.6207C0 21.8302 0.169823 22 0.37931 22H21.6207C21.8302 22 22 21.8302 22 21.6207V0.37931C22 0.169823 21.8302 0 21.6207 0H0.37931ZM9.97217 4.57516L5.16877 2.04598H9.97212L9.97217 4.57516ZM12.028 4.57518L12.0279 2.04598H16.8313L12.028 4.57518ZM2.0558 17.6329V2.72156L9.5079 6.64539L2.0558 17.6329ZM19.9442 17.6329L12.4923 6.64539L19.9442 2.72158V17.6329ZM19.0381 19.954H2.96188L11.0001 8.10228L19.0381 19.954Z" 
                        />
                    </svg>
                        
                    <div class="title ellipsis">
                        { notice.new_publication.title }
                    </div>
                {/if}

                <i 
                    class="icon-dots" 
                    on:click|stopPropagation={openActionsModal}
                    use:clickOutside
                    on:click_outside={() => isOpenActionsModal = false}
                >
                    <Modal show={isOpenActionsModal}>
                        <div class="hide-action" on:click|stopPropagation={handleVisibleNotice}>
                            {$_('HiddenNotice')}
                        </div>
                    </Modal>
                </i>
            </div>

            <div 
                class='notice-body'
                style:grid-template-columns={notice.new_publication?.videos[0]?.img_url || notice.new_publication?.img ? '1fr 90px' : '1fr'}
            >
                {#if !notice.new_publication}
                    {#if isReply}
                        <span>{$_('RepliedToComment')} { getNoticeText() }</span>
                    {:else}
                        <span>{$_('LikedComment')} { getNoticeText() }</span>
                    {/if}
                {:else}
                    <div class="text">
                        { notice.new_publication.preview_text }
                    </div>

                    {#if notice.new_publication?.videos[0]?.img_url || notice.new_publication.img}
                        <div
                            class="new-publication-img"
                            style:background={`url("${notice.new_publication?.videos[0]?.img_url || notice.new_publication.img}") no-repeat center/cover`} 
                        >
                            {#if notice.new_publication?.videos?.length === 1}
                                <i class="icon-start" />
                            {/if}

                            {#if notice.new_publication?.videos?.length > 1}
                                <div class="video-text-layout">
                                    { declination(notice.new_publication?.videos?.length, 'видео', 'видео', 'видео') }
                                </div>
                            {/if}
                        </div>
                    {/if} 
                {/if}
            </div>

            <div class="date">
                {#if !isGreenFlow }
                    {#if notice.new_publication }
                        {$_('published')}&nbsp;
                        <DateComponent createdDate={notice.new_publication.pub_start_date}/>
                    {:else}
                        <DateComponent createdDate={notice.created_at}/>
                    {/if}
                {/if}

                {#if !notice.new_publication }
                    {#if isReply }
                        {$_('toYouComment')}

                        <span class="date-receiver">
                            { getReiciverText() }
                        </span>
                    {/if}
                {/if}
            </div>
        {/if}
    </div>
{/if}

<style lang="scss">
    .notice-video-item {
        display: grid;
        grid-template-columns: 1fr 90px;
        grid-gap: 8px;
        border-bottom: 1px solid #22252C1A;
        padding-bottom: 8px;
        align-items: center;

        &:last-child {
            border-bottom: none;
        }
    }

    .icon-start {
        font-size: 10px;
    }

    .icon-start::before {
        position: relative;
        z-index: 111;
        margin-right: 0;
    }

    .icon-start::after {
        content: '';
        height: 20px;
        width: 20px;
        background-color: rgba(0, 0, 0, 0.5);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        border-radius: 50%;
    }

    .new-publication-img {
        position: relative;
        width: 90px; 
        height: 60px; 
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;

        .video-text-layout {
            background: rgba(0, 0, 0, 0.4);
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-weight: 600;
            line-height: 18px;
            color: white;
            border-radius: 4px;
        }
    }

    .text {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .avatar {
        width: 22px;
        height: 22px;
        border-radius: 50%;
    }

    .notice-header {
        display: grid;
        grid-template-columns: 22px 1fr 22px;
        grid-gap: 8px;
        align-items: center;
    }

    .hide-action {
        padding: 12px;
        white-space: nowrap;
    }
    
    .hidden-text {
        font-size: 14px;
        color: #30333D;
        line-height: 20px;
        letter-spacing: 0em;
        padding: 20px 0;
    }

    .restore {
        margin-left: 6px;
        color: #576CED;
        cursor: pointer;
    }

    .icon-dots {
        font-size: 26px;
        color: #BDBFC4;
        cursor: pointer;
        position: relative;
    }

    .icon-dots::before {
        margin: 0;
        width: 100%;
    }

    .notice {
        cursor: pointer;
        padding: 16px 20px;
        border-bottom: 1px solid #F3F3F4;
        transition: background-color .5s;
    }

    .notice.new {
        background-color: #EFF1FD;
    }

    .notice:last-child {
        margin-bottom: 0;
    }

    .icon-comment-solid,
    .icon-heart-solid {
        z-index: 1;
        position: absolute;
        font-size: 7px;
        color: white;
        padding-left: 5px;
        margin-top: 13px;
        margin-left: 8px;
    }

    .icon-comment-solid::after,
    .icon-heart-solid::after {
        content: '';
        z-index: -1;
        width: 16px;
        border-radius: 50%;
        height: 16px;
        position: absolute;
        left: 2px;
        top: -4px;
    }

    .icon-comment-solid::after {
        background: #FFAE30;
    }

    .icon-heart-solid::after {
        background: #FA624B;
    }

    .title {
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        color: #30333D;
    }

    .ellipsis {
        white-space: nowrap;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .notice-body {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        margin: 4px 0;
        display: grid;
        grid-gap: 8px;
    }

    .date {
        font-size: 12px;
        line-height: 16px;
        color: rgba(90, 95, 109, 0.6);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .date > div {
        white-space: nowrap;
        margin-right: 3px;
    }

    .date .date-receiver {
        color: #576CED;
        margin-left: 3px;
    }

    @media (max-width: 768px) {
        .notice {
            box-shadow: 0px 2px 8px 0px #10107a29;
            margin: 16px;
            padding: 12px;
            border-radius: 10px;
        }
    }

    @media (max-width: 500px) {
        .date {
            white-space: normal;
        }

        .date-receiver {
            margin-left: 0 !important;
        }
    }
</style>